module.exports = __webpack_public_path__ + "static/img/goodsList_loading_taopin.ca8c2895.png";